import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './ProductsPmsHeader.css';

function ProductsCmHeader() {
    const { t } = useTranslation();

    return (
        <div className='product-header' style={{ backgroundImage: 'url(/images/products-cm-header.png)' }}>
            <div className='page-content d-flex align-items-center'>
                <div className='col-6 d-flex flex-column'>
                    <div className='chip-yellow'>
                        {t('Real-Time Sync Across All OTAs')}
                    </div>
                    <h1>{t('Hotel Channel Manager Software for Real-Time Distribution')}</h1>
                    <p className='body-large'>
                        {t('Maximize your hotel’s visibility and eliminate manual updates with Prostay’s powerful Channel Manager software. Seamlessly connect to all major OTAs and distribution platforms in real time, automate rate and availability syncing, and manage every channel from a centralized dashboard.')}
                    </p>
                </div>
                <div className='col img-wrapper'>
                    <img src='/images/channelmanagerheader.svg' alt={"Room planning"} />
                </div>
            </div>
        </div>
    );
}

export default ProductsCmHeader;
